// import React, { useState, useEffect, useRef } from "react";
// import TopBack from "./subcompdash/Topback";
// import avatar from "../../assets/img/avatar.png";
// import EditIcon from "../../assets/icons/bx-edit-alt.svg";
// import { useFormik } from "formik";
// import { useAuth } from "../UserProvider";
// import { firestore, storage } from "../firebase";
// // import moment from "moment";
// import firebase from "firebase";
// import "firebase/auth";
// import { useUser } from "../../contexts/UserContext/UserContext";
// const conttbig = {
//   //backgroundColor: "#F2F2FA", // #F2F2FA
//   paddingTop: "1.6rem",
//   paddingBottom: "1.6rem",
//   paddingLeft: "1.6rem",
//   paddingRight: "1.6rem",
//   borderRadius: "1.6rem",
//   marginTop: "0.7rem",
//   minHeight: "520px",
//   height: "100%",
// };

// function delay(t, v) {
//   return new Promise(function (resolve) {
//     setTimeout(resolve.bind(null, v), t);
//   });
// }

// function keepTrying(triesRemaining, storageRef) {
//   if (triesRemaining < 0) {
//     return Promise.reject("out of tries");
//   }

//   return storageRef
//     .getDownloadURL()
//     .then((url) => {
//       return url;
//     })
//     .catch((error) => {
//       switch (error.code) {
//         case "storage/object-not-found":
//           return delay(2000).then(() => {
//             return keepTrying(triesRemaining - 1, storageRef);
//           });
//         default:
//           console.log(error);
//           return Promise.reject(error);
//       }
//     });
// }

// export default function User() {
//   const {state} = useUser();
//   // const [currentUser, setcurrentUser] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [loading2, setLoading2] = useState(false);
//   const [error, setError] = useState("");
//   const [smsg, setSmsg] = useState("");

//   const [picUploading, setPicUploading] = useState(false);
//   const [showCurrentPassword, setShowCurrentPassword] = useState(false);
//   const [showNewPassword, setShowNewPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   useEffect(() => {
//     setTimeout(() => setSmsg(""), 2000);
//   }, [smsg]);

//   firestore.collection("Admin").doc(currentUser?.id).get();
//   // .then((snapshot) => setcurrentUser(snapshot.data()));

//   const userUpdateForm = useFormik({
//     initialValues: currentUser,
//     onSubmit: (values) => {
//       if (values.email) {
//         setLoading(true);
//         setError("");
//         console.log(values);
//         currentUser
//           .updateProfile({
//             displayName: values.firstName,
//           })
//           .catch((err) => {
//             console.error(err);
//             setLoading(false);
//           });
//         currentUser.updateEmail(values.email).catch((err) => {
//           setError(err);
//           setLoading(false);
//         });
//         firestore
//           .collection("Admin")
//           .doc(currentUser?.id)
//           .update(values)
//           .then((ref) => {
//             setLoading(false);
//             setSmsg("Details updated!");
//           })
//           .catch((err) => setError(err));
//       } else {
//         setError("Email can't be null");
//       }
//     },
//     enableReinitialize: true,
//   });

//   const currentPassRef = useRef();
//   const newPassRef = useRef();
//   const confirmPassRef = useRef();

//   const reauthenticate = (currentPassword) => {
//     const user = currentUser;
//     const cred = firebase.auth.EmailAuthProvider.credential(
//       user.email,
//       currentPassword
//     );
//     return user.reauthenticateAndRetrieveDataWithCredential(cred);
//   };

//   const handlePassChange = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading2(true);
//     const oldPassword = currentPassRef.current.value;
//     const newPassword = newPassRef.current.value;
//     const confirmPassword = confirmPassRef.current.value;
//     if (newPassword === confirmPassword) {
//       try {
//         // reauthenticating
//         await reauthenticate(oldPassword);
//         // updating password
//         await currentUser.updatePassword(newPassword);
//         setSmsg("Password updated!");
//         setLoading2(false);
//         currentPassRef.current.value = "";
//         newPassRef.current.value = "";
//         confirmPassRef.current.value = "";
//       } catch (error) {
//         setError(error.message);
//         setLoading2(false);
//       }
//     } else {
//       setError("Passwords didn't match");
//       setLoading2(false);
//     }
//   };

//   const dpFileChange = (e) => {
//     if (e.target.files[0]) {
//       setPicUploading(true);
//       const uploadCar1 = storage
//         .ref(`Avatars/${currentUser.id}_${e.target.files[0].name}`)
//         .put(e.target.files[0]);

//       uploadCar1.on(
//         "state_changed",
//         (snapshot) => {},
//         (error) => {
//           setError(error);
//           setPicUploading(false);
//         },
//         () => {
//           keepTrying(
//             10,
//             storage
//               .ref("Avatars")
//               .child(
//                 `${currentUser.uid}_${e.target.files[0].name
//                   .split(".")
//                   .slice(0, -1)
//                   .join(".")}_500x500.${e.target.files[0].name
//                   .split(".")
//                   .pop()}`
//               )
//           ).then((url) => {
//             firestore
//               .collection("Admin")
//               .doc(currentUser.uid)
//               .update({ displayPicture: url })
//               .then(setPicUploading(false));
//           });
//         }
//       );
//     }
//   };

//   return (
//     <>
//       <TopBack />
//       <div style={conttbig}>
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "row",
//             justifyContent: "space-between",
//           }}
//         >
//           <div className="fontbold" style={{ fontSize: "1.3rem" }}>
//             Admin details
//           </div>
//           <div style={{ color: "#95EF1F" }}>{smsg}</div>
//           {error && <div style={{ color: "red" }}>{error}</div>}
//           {picUploading && <div>Uploading, please wait...</div>}
//         </div>
//         <div style={{ display: "flex", flexDirection: "row", height: "95%" }}>
//           <div
//             style={{
//               flex: "1",
//               backgroundColor: "white",
//               borderRadius: "1.2rem",
//               marginTop: "1rem",
//               height: "100%",
//               display: "flex",
//               flexDirection: "column",
//               alignContent: "center",
//               marginRight: "1rem",
//               wordBreak: "break-word",
//             }}
//           >
//             <div
//               style={{
//                 marginLeft: "auto",
//                 marginRight: "auto",
//                 position: "relative",
//               }}
//             >
//               {currentUser?.displayPicture ? (
//                 <img
//                   src={currentUser?.displayPicture}
//                   style={{
//                     height: "10rem",
//                     width: "10rem",
//                     marginTop: "1.3rem",
//                     marginLeft: "auto",
//                     marginRight: "auto",
//                     objectFit: "cover",
//                     boxShadow: "0rem 4rem 2rem -3.4rem #5d5dff",
//                     borderRadius: "10rem",
//                   }}
//                   alt=""
//                 />
//               ) : (
//                 <img
//                   src={avatar}
//                   style={{
//                     height: "10rem",
//                     width: "10rem",
//                     marginLeft: "auto",
//                     marginRight: "auto",
//                     marginTop: "1.3rem",
//                     boxShadow: "0rem 4rem 2rem -3.4rem #5d5dff",
//                     borderRadius: "5rem",
//                   }}
//                   alt=""
//                 />
//               )}
//               <div
//                 className="onHover"
//                 style={{
//                   position: "absolute",
//                   bottom: "0",
//                   right: "0",
//                   borderRadius: "100%",
//                   backgroundColor: "#5d5dff",
//                   height: "3rem",
//                   width: "3rem",
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   cursor: "pointer",
//                 }}
//                 onClick={() => {
//                   const butt3 = document.getElementById("dpfile");
//                   butt3.click();
//                 }}
//               >
//                 <img
//                   src={EditIcon}
//                   alt=""
//                   style={{ height: "1.5rem", margin: "auto" }}
//                 />
//               </div>
//             </div>
//             <input
//               type="file"
//               id="dpfile"
//               accept="image/*"
//               onChange={dpFileChange}
//               style={{ display: "none" }}
//             />
//             <span
//               className="fontSemi"
//               style={{
//                 fontSize: "1.3rem",
//                 marginLeft: "auto",
//                 marginRight: "auto",
//                 marginTop: "1rem",
//               }}
//             >
//               {currentUser?.firstName} {currentUser?.lastName}
//             </span>
//             <span
//               className="fontRegular"
//               style={{
//                 color: "#95EF1F",
//                 fontSize: "0.9rem",
//                 marginLeft: "auto",
//                 marginRight: "auto",
//                 marginTop: "0.6rem",
//                 textAlign: "center",
//               }}
//             >
//               🟢 Active now
//             </span>
//             <table
//               className="fontRegular"
//               style={{ height: "25rem", margin: "1rem", paddingBottom: "1rem" }}
//             >
//               <tr>
//                 <td style={{ color: "#acacb9", width: "10rem" }}>First name</td>
//                 <td className="fontSemi">{currentUser?.firstName}</td>
//               </tr>
//               <tr>
//                 <td style={{ color: "#acacb9" }}>Last name</td>
//                 <td className="fontSemi">{currentUser?.lastName}</td>
//               </tr>
//               {/* <tr>
//                 <td style={{ color: "#acacb9" }}>Date of birth</td>
//                 <td className="fontSemi">
//                   {moment(Date(currentUser.dateOfBirth)).format("D/MM/YYYY")}
//                 </td>
//               </tr> */}
//               <tr>
//                 <td style={{ color: "#acacb9" }}>Contact no.</td>
//                 <td className="fontSemi">{currentUser?.phone}</td>
//               </tr>
//               <tr>
//                 <td style={{ color: "#acacb9" }}>Email</td>
//                 <td className="fontSemi">{currentUser?.email}</td>
//               </tr>
//               <tr>
//                 <td style={{ color: "#acacb9" }}>Address</td>
//                 <td className="fontSemi">{currentUser?.address}</td>
//               </tr>
//             </table>
//           </div>
//           <div style={{ flex: "2", display: "flex", flexDirection: "column" }}>
//             <div
//               style={{
//                 backgroundColor: "white",
//                 borderRadius: "1.2rem",
//                 marginTop: "1rem",
//                 marginLeft: "1rem",
//                 overflow: "none",
//                 display: "flex",
//                 flexDirection: "column",
//               }}
//             >
//               <div
//                 style={{ padding: "2rem", borderBottom: "2px solid #f2f2fa" }}
//               >
//                 <div
//                   className="fontSemi"
//                   style={{
//                     marginBottom: "2rem",
//                     display: "flex",
//                     flexDirection: "row",
//                     justifyContent: "space-between",
//                   }}
//                 >
//                   <div>Personal details</div>
//                   {/* <div style={{ color: "#95EF1F" }}>{smsg}</div> */}
//                   {/* {error && <div style={{ color: "red" }}>{error}</div>} */}
//                 </div>
//                 <form onSubmit={userUpdateForm.handleSubmit}>
//                   <table className="fontRegular usertt">
//                     <tr>
//                       <td>First name</td>
//                       <td>
//                         <input
//                           type="text"
//                           name="firstName"
//                           value={userUpdateForm.values.firstName}
//                           onChange={userUpdateForm.handleChange}
//                         />
//                       </td>
//                       <td>Last name</td>
//                       <td>
//                         <input
//                           type="text"
//                           name="lastName"
//                           value={userUpdateForm.values.lastName}
//                           onChange={userUpdateForm.handleChange}
//                         />
//                       </td>
//                     </tr>
//                     <tr>
//                       <td>Address</td>
//                       <td>
//                         <input
//                           type="text"
//                           name="address"
//                           value={userUpdateForm.values?.address}
//                           onChange={userUpdateForm.handleChange}
//                         />
//                       </td>
//                       <td>Contact number</td>
//                       <td>
//                         <input
//                           type="text"
//                           name="phone"
//                           value={userUpdateForm.values.phone}
//                           onChange={userUpdateForm.handleChange}
//                         />
//                       </td>
//                     </tr>
//                   </table>
//                   <br />
//                   {!loading ? (
//                     <div
//                       className="updatebtn fontRegular"
//                       onClick={userUpdateForm.handleSubmit}
//                     >
//                       Update
//                     </div>
//                   ) : (
//                     <div className="updatebtn fontRegular">Updating...</div>
//                   )}
//                 </form>
//               </div>
//               <div style={{ padding: "2rem" }}>
//                 <div className="fontSemi" style={{ marginBottom: "2rem" }}>
//                   Password settings
//                 </div>
//                 <form onSubmit={(e) => handlePassChange(e)}>
//                   <table
//                     className="fontRegular usertt"
//                     style={{ width: "60%" }}
//                   >
//                     <tr>
//                       <td> Current password</td>
//                       <td>
//                         <input
//                           type={showCurrentPassword ? "text" : "password"}
//                           ref={currentPassRef}
//                           name="currentpass"
//                           required
//                         />
//                         {showCurrentPassword ? (
//                           <i
//                             style={{
//                               marginLeft: "0.5rem",
//                               opacity: "0.5",
//                               cursor: "pointer",
//                             }}
//                             className="fas fa-eye"
//                             onClick={() => {
//                               setShowCurrentPassword(!showCurrentPassword);
//                             }}
//                           ></i>
//                         ) : (
//                           <i
//                             style={{
//                               marginLeft: "0.5rem",
//                               opacity: "0.5",
//                               cursor: "pointer",
//                             }}
//                             className="fas fa-eye-slash"
//                             onClick={() => {
//                               setShowCurrentPassword(!showCurrentPassword);
//                             }}
//                           ></i>
//                         )}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td> New password</td>
//                       <td>
//                         <input
//                           type={showNewPassword ? "text" : "password"}
//                           ref={newPassRef}
//                           name="newpass"
//                           required
//                         />
//                         {showNewPassword ? (
//                           <i
//                             style={{
//                               marginLeft: "0.5rem",
//                               opacity: "0.5",
//                               cursor: "pointer",
//                             }}
//                             className="fas fa-eye"
//                             onClick={() => {
//                               setShowNewPassword(!showNewPassword);
//                             }}
//                           ></i>
//                         ) : (
//                           <i
//                             style={{
//                               marginLeft: "0.5rem",
//                               opacity: "0.5",
//                               cursor: "pointer",
//                             }}
//                             className="fas fa-eye-slash"
//                             onClick={() => {
//                               setShowNewPassword(!showNewPassword);
//                             }}
//                           ></i>
//                         )}
//                       </td>
//                     </tr>
//                     <tr>
//                       <td> Confirm password</td>
//                       <td>
//                         <input
//                           type={showConfirmPassword ? "text" : "password"}
//                           ref={confirmPassRef}
//                           name="confirmpass"
//                           required
//                         />
//                         {showConfirmPassword ? (
//                           <i
//                             style={{
//                               marginLeft: "0.5rem",
//                               opacity: "0.5",
//                               cursor: "pointer",
//                             }}
//                             className="fas fa-eye"
//                             onClick={() => {
//                               setShowConfirmPassword(!showConfirmPassword);
//                             }}
//                           ></i>
//                         ) : (
//                           <i
//                             style={{
//                               marginLeft: "0.5rem",
//                               opacity: "0.5",
//                               cursor: "pointer",
//                             }}
//                             className="fas fa-eye-slash"
//                             onClick={() => {
//                               setShowConfirmPassword(!showConfirmPassword);
//                             }}
//                           ></i>
//                         )}
//                       </td>
//                     </tr>
//                   </table>
//                   <br />
//                   {!loading2 ? (
//                     <button
//                       type="submit"
//                       style={{ border: "none", outline: "none", width: "7rem" }}
//                       className="updatebtn fontRegular"
//                     >
//                       Update
//                     </button>
//                   ) : (
//                     <button
//                       disabled
//                       style={{ border: "none", outline: "none", width: "7rem" }}
//                       className="updatebtn fontRegular"
//                     >
//                       Updating...
//                     </button>
//                   )}
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

import React from "react";
import { useUser } from "../../contexts/UserContext/UserContext";

const User = () => {
    const { state } = useUser();
    return (
        <div>
            <h1>User</h1>
            <p>Welcome, {state?.user?.email}!</p>
        </div>
    );
};

export default User;
